import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import classNames from 'classnames';

import styles from './CheckBoxFilter.module.scss';

const CheckBoxFilter = ({
    title,
    filters,
    activeFilterGroups,
    onChange = () => null,
    onClearAll = () => null,
}) => {
    const { t } = useTranslation();

    return (
        <div className={styles['CheckBoxFilter']}>
            <h3 className={styles['CheckBoxFilter__Title']}>{title}</h3>
            <div className={styles['CheckBoxFilter__Wrapper']}>
                {filters.map((filter, index) => (
                    <div className={styles['CheckBoxFilter__Item']} key={index}>
                        <h3 className={styles['CheckBoxFilter__Item__Title']}>
                            {t(`checkBoxFilter.${filter.title.toLowerCase()}`)}
                        </h3>
                        {filter.items && (
                            <List
                                group={filter.group}
                                items={filter.items || []}
                                onChange={onChange}
                                activeFilters={
                                    activeFilterGroups
                                        ? activeFilterGroups[filter.group]
                                        : []
                                }
                            />
                        )}
                    </div>
                ))}
            </div>
            <button
                className={styles['CheckBoxFilter__Clear']}
                onClick={onClearAll}
            >
                {t('checkBoxFilter.clearAll')}
            </button>
        </div>
    );
};

const List = ({ items, activeFilters = [], onChange, group }) => {
    const { t } = useTranslation();

    const [shouldShowAll, setShouldShowAll] = useState(items.length < 9);

    const handleShowMore = () => {
        setShouldShowAll(true);
    };

    let currentItems = [...items];
    currentItems = !shouldShowAll ? currentItems.slice(0, 9) : currentItems;

    return (
        <div className={styles['CheckBoxFilter__List']}>
            <div className={styles['CheckBoxFilter__List__Container']}>
                {currentItems.map((item) => (
                    <Item
                        key={item.slug}
                        group={group}
                        name={item.label}
                        slug={item.slug}
                        onChange={onChange}
                        checked={activeFilters.includes(item.slug)}
                    />
                ))}
            </div>
            {!shouldShowAll && (
                <span
                    className={styles['CheckBoxFilter__Expand']}
                    onClick={handleShowMore}
                >
                    {t('checkBoxFilter.expand')}
                </span>
            )}
        </div>
    );
};

const Item = ({ name, slug, onChange, checked, group }) => {
    const classes = classNames(styles['CheckBoxFilter__Label'], {
        [styles['CheckBoxFilter__Label--Active']]: checked,
    });

    return (
        <label className={classes}>
            {name}
            <input
                type="checkbox"
                name={name}
                value={slug}
                checked={checked}
                onChange={() => onChange(slug, group, !checked)}
            />
        </label>
    );
};

CheckBoxFilter.propTypes = {
    title: PropTypes.string,
    filters: PropTypes.array,
    checkedFilters: PropTypes.object,
    handleFilter: PropTypes.func,
    handleClearAll: PropTypes.func,
};

CheckBoxFilter.defaultProps = {
    filters: [],
};

export default CheckBoxFilter;
